export default "__VITE_ASSET__CqsZgRci__"